import { Box, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import MotionWrapper from "../../../../../components/MotionWrapper";
import { getCourseFeeOptions } from "../../../../../redux/features/generalSlice";
import useResponsive from "../../../../../Hooks/useResponsive";
import NoDataFound from "../../../../../components/NodataIndication/NoDataFound";

const CourseSessionPrize = ({
  selectedSessionFee,
  setSelectedSessionFee,
  item,
  update,
  currecyType,
}) => {
  const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");
  const dispatch = useDispatch();
  const { sessionPrize } = useSelector((state) => state.general);
  const selectedRef = useRef(null);
  const containerRef = useRef(null);
  const [priceId, setPriceId] = React.useState(null);

  useEffect(() => {
    if (priceId || item.priceId) {
      const data = {
        finYear: 2025,
        courseId: priceId || item.priceId,
        currency: currecyType,
      };
      dispatch(getCourseFeeOptions(data));
    }
  }, [currecyType]);

  useEffect(() => {
    if (selectedRef.current && containerRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedSessionFee]);

  const handleClick = (e, item) => {
    setSelectedSessionFee("");
    setPriceId(item.id);
    const data = { finYear: 2025, courseId: item.id, currency: currecyType };
    dispatch(getCourseFeeOptions(data));
    setSelectedSessionFee(item);
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        flexGrow: 1,
        height: "500px",
        overflowY: "auto",
        paddingRight: "8px",
        backgroundColor: "grey.200",
        padding: 2,
        borderRadius: 3,
      }}
    >
      {sessionPrize.length > 0 ? (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {sessionPrize.length > 0 &&
            sessionPrize.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={13}
                md={selectedSessionFee ? 12 : 4}
                key={index}
              >
                <MotionWrapper delay={0.5} directions={"top"}>
                  <Box
                    sx={{ display: "flex", justifyContent: "center" }}
                    onClick={(e) => handleClick(e, item)}
                    ref={
                      selectedSessionFee?.id === item.id ? selectedRef : null
                    }
                  >
                    <Paper
                      sx={{
                        background:
                          "linear-gradient(to right, #702dff, black, black)",
                        borderRadius: 2,
                        color: "white",
                        padding: 4,
                      }}
                    >
                      <Box>
                        <Typography>{`Session : ${item.session}`}</Typography>
                      </Box>
                      <Box>
                        <Typography>{`Price INR : ${item.price}`}</Typography>
                      </Box>
                      <Box>
                        <Typography>{`Price AED : ${item.priceAed}`}</Typography>
                      </Box>
                      <Box>
                        <Typography>{`Converted INR : ${item.convertedInr}`}</Typography>
                      </Box>
                      <MotionWrapper delay={0.5} directions={"bottom"}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            pt: 1,
                          }}
                        >
                          {selectedSessionFee &&
                          selectedSessionFee.id === item.id ? (
                            <Box
                              sx={{
                                height: 10,
                                width: 40,
                                backgroundColor: "rgba(0, 255, 0, 0.6)", // Green with transparency
                                borderRadius: 3,
                                boxShadow: "0 0 7px 4px rgba(0, 255, 0, 0.8)", // Green glow effect
                              }}
                            ></Box>
                          ) : null}
                        </Box>
                      </MotionWrapper>
                    </Paper>
                  </Box>
                </MotionWrapper>
              </Grid>
            ))}
        </Grid>
      ) : (
        <NoDataFound />
      )}
    </Box>
  );
};

export default CourseSessionPrize;
